{
  "fr": {
    "decision_type": {
      "actions": {
        "add_competitor": "Ajouter concurrent",
        "add_decision_partners": "Ajouter partenaires de décision",
        "change_rights": "Modifier les droits",
        "create_category": "Ajouter une nouvelle catégorie",
        "delete": "Supprimer",
        "deleteMultiple": "Supprimer...",
        "delete_cancel": "Annuler",
        "download": "Télécharger",
        "edit": "Modifier",
        "edit_decision_partners": "Modifier les partenaires de décision",
        "import": "Importation",
        "new": "Nouveau",
        "newDecision": "Nouvelle décision",
        "newDecisions": "Décision",
        "save": "Sauvegardez",
        "show": "Affichez",
        "start_new_group": "Démarrer un nouveau groupe",
        "submit": "Enregistrer"
      },
      "attributes": {
        "category": "Catégorie",
        "created_at": "Créé à",
        "description": "Description",
        "name": "Titre",
        "responsible": "Responsable",
        "start_date": "Date de début"
      },
      "labels": {
        "add_decision_partners": "Ajouter des partenaires de décision",
        "allowCreditExplainer": "Afficher le crédit pour les propositions sous budget",
        "auto_close": "Clôturer la décision automatiquement une fois le délai passé",
        "auto_close_info": "La décision de clôture empêche le client d'approuver une proposition lorsqu'aucune décision n'a été prise. Ceci est utile lorsque vous travaillez avec des délais serrés.",
        "category_name": "Nom de la catégorie",
        "closes_on_deadline": "Ferme après la date limite",
        "createNewPartner": "Ou créez un nouveau partenaire",
        "decision_type_category_description": "L'attribution d'une catégorie telle que la cuisine, la salle de bain, etc. à plusieurs décisions les regroupera et permettra une meilleure surveillance",
        "deleteCategory": "Supprimer la catégorie {category} ?",
        "deleteGroupSubtitle": "Cela supprimera toutes les conversations, propositions et documents créés par tous les membres dans {group_name} de la décision {decision_type_name}.",
        "deleteGroupTitle": "Vous êtes en train de supprimer {group_name}",
        "disclaimerDeleteGroup": "La suppression de {group_name} annulera la publication de toutes les décisions pour les partenaires de décision. Vous pouvez publier à nouveau aux partenaires de décision une fois que cette décision aura de nouveau des partenaires de décision.",
        "disclamerDeleteCategory": "La suppression de {category} retirera la catégorie de toutes les décisions qui lui sont associées. Les décisions elles-mêmes ne seront pas supprimées.",
        "editCategory": "Modifier la catégorie",
        "editGroup": "Modifier {group_name}",
        "editPartnerRights": "Modifier les droits de communication des partenaires de décision",
        "editPartnerRightsLater": "Vous pouvez toujours changer cela plus tard",
        "existing_groups": "Groupes partenaires existants",
        "explainerPartners": "Ajouter des partenaires de décision externes et travaillez ensemble sur {decision_type_name}",
        "export_preparing": "La collecte de toutes les propositions peut prendre jusqu'à quelques minutes. Vous recevrez une notification lorsqu'elle sera prête à être téléchargée.",
        "export_proposals_approved": "Documents approuvés",
        "groupRightsWarning": "Soyez averti! Toutes les conversations entre le client et les partenaires de décision seront supprimées. Cette action est irréversible. Voulez-vous vraiment continuer?",
        "hint": "Je peux consulter des catégories ainsi que des instructions dans le",
        "hintSettings": "bedrijfsinstellingen.",
        "last_updated_at": "Dernière mise à jour",
        "matrix": "Statistiques",
        "new_category": "Nouvelle catégorie de décision",
        "noPartnersAddedYet": "Aucun partenaire ajouté pour le moment",
        "noResultPartner": "Aucun résultat pour {partner_name}",
        "partner_group": "Groupe de partenaires",
        "partners": "Partenaires de décision",
        "projectUnitsTotal": "{project_name} a {units_count_max} unités au total",
        "proposal_uploaded": "proposition téléchargée",
        "published_state": "Published status",
        "searchPartners": "Cherchez les partenaires de décision",
        "selectADecision": "Sélectionner une décision",
        "select_decision_partners": "Sélectionnez vos partenaires de décision",
        "setUpPartners": "Mettez en place des partenaires de décision",
        "set_rights": "Définir les droits de groupe pour {partner_group_name}",
        "start_date_description": "Date à usage interne uniquement. Cela pourrait être utilisé pour déterminer l'ordre dans lequel les décisions sont travaillées par votre équipe",
        "start_date_title": "Date de début (facultatif)",
        "step0Title": "Quel modèle de projet et de décision souhaitez-vous utiliser ?",
        "step1Title": "Quelle décision vos clients doivent-ils prendre?",
        "tab_proposal_templates": "Modèles de proposition",
        "tab_units": "Unités",
        "upsellCategoryTypes": "Cette fonctionnalité n'est pas incluse dans votre forfait. Contactez-nous via le bouton bleu pour en savoir plus.",
        "view": "Vue générale",
        "view_list": "Liste",
        "view_table": "Table",
        "writeEmployeeNameReject": "Noter <i><b>{employeeName}</b></i> pour terminer la suppression."
      },
      "snackbars": {
        "duplicate": "La décision a été créée, mais le processus de copie à partir du modèle peut prendre quelques minutes."
      },
      "toasts": {
        "bulk_delete": "Décision supprimée avec succès | Décisions supprimées avec succès",
        "update": "Décision mise à jour avec succès"
      },
      "validation": {
        "duplicateNameAlreadyTaken": "'{name}' est déjà utilisé pour ce projet",
        "nameAlreadyTaken": "Le titre est déjà utilisé pour ce projet",
        "needName": "Champs requis",
        "projectRequired": "Sélectionnez un projet d'abord",
        "selectDecisionType": "Sélectionnez au moins 1 décision",
        "selectSharingOption": "Veuillez sélectionner avec qui vous souhaitez partager le(s) document(s)"
      }
    }
  }
}
